import React from 'react'
import { Outlet } from 'react-router-dom'

import { AnalyticsFiltersProvider } from './modules/AnalyticsFilters/contexts/AnalyticsFiltersContext'

export const Analytics = () => {
  return (
    <AnalyticsFiltersProvider>
      <Outlet />
    </AnalyticsFiltersProvider>
  )
}
